function _s(o, i, p, l) {
  void 0 === i && (i = 400);
  void 0 === l && (l = !1);

  o.style.overflow = "hidden";
  l && (o.style.display = "block");

  var n,
    t = window.getComputedStyle(o),
    s = parseFloat(t.getPropertyValue("height")),
    a = parseFloat(t.getPropertyValue("padding-top")),
    r = parseFloat(t.getPropertyValue("padding-bottom")),
    y = parseFloat(t.getPropertyValue("margin-top")),
    d = parseFloat(t.getPropertyValue("margin-bottom")),
    g = s / i,
    m = a / i,
    h = r / i,
    u = y / i,
    x = d / i;

  window.requestAnimationFrame(function t(e) {
    void 0 === n && (n = e);
    e -= n;

    if (l) {
      o.style.height = g * e + "px";
      o.style.paddingTop = m * e + "px";
      o.style.paddingBottom = h * e + "px";
      o.style.marginTop = u * e + "px";
      o.style.marginBottom = x * e + "px";
    } else {
      o.style.height = s - g * e + "px";
      o.style.paddingTop = a - m * e + "px";
      o.style.paddingBottom = r - h * e + "px";
      o.style.marginTop = y - u * e + "px";
      o.style.marginBottom = d - x * e + "px";
    }

    if (i <= e) {
      o.style.height = "";
      o.style.paddingTop = "";
      o.style.paddingBottom = "";
      o.style.marginTop = "";
      o.style.marginBottom = "";
      o.style.overflow = "";

      if (!l) o.style.display = "none";
      if (typeof p === "function") p();
    } else {
      window.requestAnimationFrame(t);
    }
  });
}

HTMLElement.prototype.slideToggle = function (t, e) {
  0 === this.clientHeight ? _s(this, t, e, !0) : _s(this, t, e);
};

HTMLElement.prototype.slideUp = function (t, e) {
  _s(this, t, e);
};

HTMLElement.prototype.slideDown = function (t, e) {
  _s(this, t, e, !0);
};

class TabsSection extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.init();

    const firstCategorySection = document.querySelector(
      "[data-category-section]:first-of-type"
    );
    if (firstCategorySection) {
      firstCategorySection.style.display = "block";
      const firstCategory = firstCategorySection.getAttribute(
        "data-category-section"
      );
      const firstButton = document.querySelector(
        `[data-category-open="${firstCategory}"]`
      );
      if (firstButton) firstButton.classList.add("active-faq");
    }

    this.querySelectorAll(".faq-item-text").forEach((item) => {
      item.style.display = "none";
    });

    this.querySelectorAll(".faq-item-title").forEach((button) => {
      button.addEventListener("click", this.toggleFaqItem.bind(this));
    });

    this.querySelectorAll("[data-category-open]").forEach((category) => {
      category.addEventListener("click", this.switchCategorie.bind(this));
    });

    const buttons = this.querySelectorAll(".category-button-faq");
    buttons.forEach((button) => {
      button.addEventListener("click", this.toggleActiveButton.bind(this));
    });

    this.on_process = false;
  }

  toggleActiveButton(e) {
    this.querySelectorAll(".category-button-faq").forEach((button) => {
      button.classList.remove("active-faq");
    });
    e.currentTarget.classList.add("active-faq");

    e.currentTarget.classList.add("active-faq");
  }

  toggleFaqItem(e) {
    e.stopPropagation();
    if (this.on_process == false) {
      this.on_process = true;

      const currentItem = e.currentTarget.parentNode;
      const allItems = document.querySelectorAll(".faq-item-active");

      allItems.forEach((item) => {
        if (item !== currentItem) {
          item.classList.remove("faq-item-active");
          item.querySelector(".faq-item-text").slideUp(250);
        }
      });

      const item = currentItem.querySelector(".faq-item-text");
      item.closest(".tabs-section__item").classList.toggle("faq-item-active");
      item.slideToggle(250);

      setTimeout(() => {
        this.on_process = false;
      }, 400);
    }
  }

  switchCategorie(e) {
    const category = e.currentTarget.getAttribute("data-category-open");

    const sectionToScrollTo = document.querySelector(
      `[data-category-section="${category}"]`
    );

    if (sectionToScrollTo) {
      const headerOffset = 140;
      const elementPosition = sectionToScrollTo.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  }

  init() {
    this.swiper = new Swiper(this.querySelector(".swiper-button-faq"), {
      direction: "horizontal",
      loop: false,
      slidesPerView: "auto",
      spaceBetween: 8,
      slidesOffsetBefore: 20,
    });
  }
}

customElements.define("tabs-section", TabsSection);

class SwiperButtonCollapse extends HTMLElement {
  constructor() {
    super();

    const categoryButtons = document.querySelectorAll(".category-button");
    const faqItems = document.querySelectorAll(".faq-item");

    faqItems.forEach(function (item) {
      item.style.display = "none";
    });

    const firstCategory = categoryButtons[0].getAttribute("data-category");
    categoryButtons[0].classList.add("active-faq");
    faqItems.forEach(function (item) {
      if (item.getAttribute("data-category") === firstCategory) {
        item.style.display = "block";
      }
    });

    categoryButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        categoryButtons.forEach(function (btn) {
          btn.classList.remove("active-faq");
        });

        this.classList.add("active-faq");

        const selectedCategory = this.getAttribute("data-category");

        faqItems.forEach(function (item) {
          if (item.getAttribute("data-category") === selectedCategory) {
            item.style.display = "block";
          } else {
            item.style.display = "none";
          }
        });
      });
    });

    this.swiper = new Swiper(this.querySelector(".swiper-collapse"), {
      direction: "horizontal",
      loop: false,
      slidesPerView: "auto",
    });
  }
}
customElements.define("swiper-button-collapse", SwiperButtonCollapse);
